import connect from 'react-redux/es/connect/connect';
import { confirmOrder, acceptTermsAndConditions } from '../actions/cart';
import PaymentPage from '../pages/payment/PaymentPage';
import { setLoggedInUser } from '../actions/user';

const mapStateToProps = state => {
    return {
        cartItems: state.cart.cartItems,
        customer: state.user.customer,
        booker: state.cart.booker,
        user: state.user.user,
        termsAndConditions: state.cart.termsAccepted
    };
};

const mapDispatchToProps = dispatch => ({
    confirmOrder: (note, paymentIntent, usedPaymentMethod, bookingNotification, source_id) => {
        dispatch(
            confirmOrder(note, paymentIntent, usedPaymentMethod, bookingNotification, source_id)
        );
    },
    setTermsAndConditions: accepted => dispatch(acceptTermsAndConditions(accepted)),
    setLoggedInUser: user => {
        dispatch(setLoggedInUser(user));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);
